import React from 'react';
import * as S from './LandingPageBanner.styles';
import Image from 'next/image';
import { Title } from '@mantine/core';

type LandingPageBannerProps = {
  banner: string;
  title: string;
  textAlignment?: 'center' | 'bottom-left';
  imgSize?: number;
  imgFit?: 'contain' | 'cover';
  description?: JSX.Element;
  isBlogDetail?: boolean;
};

const LandingPageBanner: React.FC<LandingPageBannerProps> = ({
  banner,
  title,
  description,
  textAlignment = 'center',
  imgFit = 'cover',
  imgSize,
  isBlogDetail = false,
}) => {
  return (
    <S.Wrapper img={imgFit} imgSize={imgSize} isBlogDetail={isBlogDetail}>
      <div className="overlay" />
      <Image quality={100} src={banner} fill alt="" />
      <div>
        {textAlignment === 'center' && <Title>{title}</Title>}
        {textAlignment === 'bottom-left' && <Title>{title}</Title>}
        {description ? description : null}
      </div>
    </S.Wrapper>
  );
};

export default LandingPageBanner;
